import { ApiUrl, crosstableUrl } from 'src/constants';
import { httpService } from 'src/services';
import { HydraResponse } from './hydraResponse';
import { IPanoramaWrapper } from '../store/panorama/reducer';

export function getPanoramaData(id: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getPanoramaInfo}/${id}`, {}, {});
}

export function getPanoramaByEntity(id: number | string, entityName: string) {
  return httpService.get(`${crosstableUrl}/${entityName}_panorama_v2_views?${entityName}=${id}&pagination=false`, {}, {});
}

export function getPanoramaByEntityBatch(ids: string[], entityName: string): Promise<HydraResponse<IPanoramaWrapper[]>> {
  const idsString = ids.reduce((acc, id) => `${acc}&${entityName}[]=${id}`, '');
  return httpService.get(`${crosstableUrl}/${entityName}_panorama_v2_views?${idsString}&pagination=false`, {}, {});
}
